import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-openid',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>OpenID icon</title><path d="M14.54.889l-3.63 1.773v18.17c-4.15-.52-7.27-2.78-7.27-5.5 0-2.58 2.8-4.75 6.63-5.41v-2.31C4.42 8.322 0 11.502 0 15.332c0 3.96 4.74 7.24 10.91 7.78l3.63-1.71V.888m.64 6.724v2.31c1.43.25 2.71.7 3.76 1.31l-1.97 1.11 7.03 1.53-.5-5.21-1.87 1.06c-1.74-1.06-3.96-1.81-6.45-2.11z"/></svg>`,
    styles: []
})
export class SimpleIconsOpenidComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#F78C40';
    @Input() className: string = 'simple-icons-openid'
    constructor() {}
    ngOnInit(): void {}
}
